import React from 'react';

import { Skeleton } from '@mui/material';

import Preview from './Preview';
import useMessagePreview from './useMessagePreview';

export default function PreviewBody() {
  const { error, loading, data } = useMessagePreview();
  const subject = data ? data.subject : <Skeleton width={300} sx={{ display: 'inline-block', ml: 1 }} />;
  const preheader = <>{data && data.preheader}</>;
  const bodyHtml = data ? data.bodyHtml : null;
  return <Preview loading={loading} errorMessage={error} subject={subject} preheader={preheader} bodyHtml={bodyHtml} />;
}
